<ax-day-edit
  *ngFor="let openingDay of combinedOpeningDays; let index = index"
  [name]="name + ' day' + index"
  [group]="openingDay.combined"
  [cleared]="cleared"
  [readonly]="readonly"
  (add)="_add($event)"
  (remove)="_remove($event)"
></ax-day-edit>
